import { useQuery } from 'react-query'

import { getContactPropertyDefinitions } from 'api/properties'

export const useContactProperties = ()  => {
  const {
    isLoading,
    error,
    data: properties = []
  } = useQuery('contact_properties',
    () => (
      getContactPropertyDefinitions()
        .then(({ data }) => (data))
    ))

  return [properties, {
    error,
    isLoading
  }]
}
